import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './LangSwitcher.scss';
import Dropdown from '../input/Dropdown';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';
import { locale } from 'primereact/api';

const LangSwitcher = ({ showSeparator=true, noBorder=true, onChange }) => {
    

    const { i18n } = useTranslation();

    const languages = [
        { code: 'en', label: 'EN' },
        { code: 'pl', label: 'PL' }
    ];

    const [selectedLang, setSelectedLang] = useState('en');

    useEffect(() => {
        const langCode = localStorage.getItem('lang');
        if (langCode && languages.find(lang => lang.code === langCode)) {
            setSelectedLang(languages.find(lang => lang.code === langCode));
        } else {
            setSelectedLang(languages[0]);
        }
    }, []);

    useEffect(() => {
        changeLanguage(selectedLang.code);
        locale(selectedLang.code)
    }, [selectedLang]);

    const changeLanguage = (langCode) => {
        if (langCode) {
            i18n.changeLanguage(langCode);
            localStorage.setItem('lang', langCode);
        }
    }



    return (
        <div className='lang-switcher'>
            {showSeparator && <div className="separator" />}
            <Dropdown id='lang' value={selectedLang} dataKey='code' optionLabel='label' options={languages} small className={classNames('m-0', {'no-border': noBorder})}
                onChange={e => {
                    setSelectedLang(e.target.value);
                 }} 
            />
        </div>
    );
};

export default LangSwitcher;
